export const manifestColumns = [
    {
        field: "lineNo",
        headerName: "Line No",
        align: "right",
    },
    {
        field: "doNumber",
        headerName: "DO Number",
        left:80,
        width:150
    },
    {
        field: "orderNumber",
        headerName: "Order Number",
        width: 180,
    },
    {
        field: "custOrdNbr",
        headerName: "Customer Order Number",
        width: 220,
        // align: "right",
        // left: 290,
        // left: 220
    },
    {
        field: "tPallet",
        headerName: "T Pallet",
        // sortable: false,
        width: 100,
        align: "right",
        //flex: 0.35,
    },
    {
        field: "tSmallCarton",
        headerName: "T Small Carton",
        // sortable: false,
        width: 150,
        align: "right",
        //flex: 0.35,
    },
    {
        field: "tMediumCarton",
        headerName: "T Medium Carton",
        // sortable: false,
        width: 150,
        align: "right",
        //flex: 0.35,
    },
    {
        field: "tLargeCarton",
        headerName: "T Large Carton",
        // sortable: false,
        width: 150,
        align: "right",
        //flex: 0.35,
    },
    {
        field: "grossWeight",
        headerName: "Gross Weight",
        // sortable: false,
        width: 140,
        align: "right",
        //flex: 0.35,
    },
    {
        field: "cubic",
        headerName: "Cubic",
        //headerAlign:"center",
        // sortable: false,
        width: 100,
        align: "right",
        //flex: 0.35,
    },
]

export const manifestColumns2 = [
    {
        field: "doNumber",
        headerName: "DO Number",
        left:80,
        width: 220,
    },
    {
        field: "orderNumber",
        headerName: "Order Number",
        left:300
    },
    {
        field: "custOrdNbr",
        headerName: "Customer Order Number",
        width: 220,
        // align: "right",
        // left: 290,
        // left: 220
    },
    {
        field: "tPallet",
        headerName: "T Pallet",
        // sortable: false,
        width: 100,
        //flex: 0.35,
    },
    {
        field: "tSmallCarton",
        headerName: "T Small Carton",
        // sortable: false,
        width: 150,
        //flex: 0.35,
    },
    {
        field: "tMediumCarton",
        headerName: "T Medium Carton",
        // sortable: false,
        width: 150,
        //flex: 0.35,
    },
    {
        field: "tLargeCarton",
        headerName: "T Large Carton",
        // sortable: false,
        width: 150,
        //flex: 0.35,
    },
    {
        field: "grossWeight",
        headerName: "Gross Weight",
        // sortable: false,
        width: 150,
        //flex: 0.35,
    },
    {
        field: "cubic",
        headerName: "Cubic",
        // sortable: false,
        width: 100,
        //flex: 0.35,
    },
]